var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 32,
    fill: "#0072FF",
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.361 20.103c1.776 0 2.82-.849 2.823-2.18-.003-1.211-.916-1.854-2.18-2.138l-.654-.156c-.632-.146-1.16-.38-1.15-.902 0-.47.415-.814 1.168-.814.735 0 1.186.334 1.243.906h1.474c-.022-1.296-1.087-2.191-2.706-2.191-1.595 0-2.763.88-2.756 2.202-.003 1.072.753 1.686 1.982 1.981l.792.199c.791.192 1.232.419 1.235.909-.003.533-.507.895-1.289.895-.799 0-1.374-.37-1.424-1.097h-1.488c.04 1.573 1.165 2.386 2.93 2.386zm5.463-.032c.82 0 1.41-.423 1.655-1.062h.057V20h1.452v-5.455h-1.513v3.133c.004.731-.497 1.115-1.04 1.115-.572 0-.941-.402-.945-1.044v-3.204h-1.513v3.473c.004 1.275.75 2.053 1.847 2.053zm7.299.018c1.243 0 2.212-.984 2.212-2.81 0-1.874-1.012-2.805-2.209-2.805-.912 0-1.35.544-1.552.988h-.046v-2.735h-1.513V20h1.492v-.874h.067c.21.455.668.963 1.549.963zm-.48-1.204c-.728 0-1.147-.64-1.147-1.612 0-.973.412-1.595 1.147-1.595.75 0 1.147.65 1.147 1.595 0 .951-.405 1.612-1.147 1.612zM30.644 20v-3.274c0-.604.384-1.005.888-1.005.497 0 .831.34.831.877V20h1.467v-3.331c0-.565.323-.948.873-.948.483 0 .846.302.846.909V20h1.509v-3.668c0-1.183-.703-1.858-1.719-1.858-.799 0-1.42.409-1.644 1.034h-.057c-.174-.632-.732-1.034-1.48-1.034-.736 0-1.293.391-1.52 1.034h-.065v-.963h-1.441V20h1.512zm8.159-6.158c.45 0 .82-.344.82-.767 0-.419-.37-.763-.82-.763-.448 0-.817.344-.817.763 0 .423.37.767.817.767zM39.555 20v-5.455h-1.512V20h1.512zm3.18.075c.39-.015.667-.093.82-.142l-.238-1.126c-.074.014-.234.05-.376.05-.302 0-.512-.114-.512-.533v-2.642h1.027v-1.137h-1.027V13.24h-1.512v1.306h-.746v1.137h.746v2.84c-.007 1.07.72 1.599 1.818 1.553zm5.162.028c.806 0 1.328-.352 1.594-.86h.043V20h1.435v-3.679c0-1.3-1.101-1.847-2.316-1.847-1.306 0-2.166.625-2.375 1.62l1.399.113c.103-.362.426-.628.97-.628.514 0 .809.26.809.707v.02c0 .352-.373.399-1.321.49-1.08.1-2.05.463-2.05 1.68 0 1.08.772 1.627 1.812 1.627zm.433-1.044c-.465 0-.799-.217-.799-.632 0-.426.352-.636.884-.71.33-.047.87-.125 1.052-.245v.578c0 .572-.473 1.009-1.137 1.009zM53.45 20v-3.153c.003-.704.422-1.115 1.033-1.115.607 0 .973.397.97 1.065V20h1.512v-3.473c0-1.271-.745-2.053-1.882-2.053-.81 0-1.395.398-1.64 1.034h-.064v-.963h-1.442V20h1.513zm6.73.107c1.414 0 2.426-.721 2.43-1.797-.004-.789-.52-1.261-1.578-1.478l-.987-.198c-.508-.11-.696-.285-.692-.547-.004-.327.366-.54.834-.54.526 0 .838.288.913.64l1.385-.086c-.135-1.005-.945-1.627-2.323-1.627-1.395 0-2.315.647-2.311 1.698-.004.817.511 1.346 1.576 1.559l.945.188c.476.096.692.27.7.543-.008.324-.36.554-.888.554-.54 0-.899-.23-.991-.674l-1.488.078c.142 1.044 1.03 1.687 2.475 1.687zM66.03 20l.938-3.43h.067l.938 3.43h1.601l1.481-5.455h-1.527l-.831 3.644h-.046l-.895-3.644h-1.502l-.88 3.665h-.05l-.846-3.665h-1.53L64.43 20h1.598zm7.97.107c1.35 0 2.259-.657 2.472-1.67l-1.4-.092c-.152.416-.543.632-1.047.632-.756 0-1.236-.5-1.236-1.314v-.003h3.715v-.416c0-1.853-1.123-2.77-2.564-2.77-1.605 0-2.646 1.14-2.646 2.824 0 1.729 1.026 2.809 2.706 2.809zm1.08-3.385h-2.29c.031-.621.503-1.118 1.175-1.118.656 0 1.111.468 1.115 1.118zM78.794 20v-3.086c0-.671.49-1.133 1.158-1.133.21 0 .497.036.64.082V14.52c-.136-.032-.324-.054-.477-.054-.61 0-1.111.355-1.31 1.03h-.057v-.952h-1.467V20h1.513zm4.6.107c1.414 0 2.426-.721 2.43-1.797-.004-.789-.52-1.261-1.578-1.478l-.987-.198c-.508-.11-.696-.285-.692-.547-.004-.327.366-.54.834-.54.526 0 .838.288.913.64l1.385-.086c-.135-1.005-.945-1.627-2.323-1.627-1.395 0-2.315.647-2.311 1.698-.004.817.511 1.346 1.576 1.559l.945.188c.476.096.692.27.7.543-.008.324-.36.554-.888.554-.54 0-.899-.23-.991-.674l-1.488.078c.142 1.044 1.03 1.687 2.475 1.687z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 84)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 27,
    y: 19,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 4,
    x: 27,
    y: 7,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 5,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 15,
    y: 5,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 15,
    y: 17,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 4,
    x: 27,
    y: 31,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 15,
    y: 29,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 29,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 17,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 27,
    y: 43,
    fill: "#99C7FF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 3,
    y: 41,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z",
    transform: "translate(0 36)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 15,
    y: 41,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.17c.238-.227.625-.227.864 0 .22.211.237.542.05.77l-.05.056-5.111 4.833c-.22.21-.567.227-.807.049l-.057-.049-2.667-2.5c-.239-.228-.239-.597 0-.825.22-.21.567-.226.807-.048l.057.048 2.235 2.087 4.679-4.42z",
    transform: "translate(12 24)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.07 16h-5c-.552 0-1 .448-1 1s.448 1 1 1h5c.552 0 1-.448 1-1s-.448-1-1-1zm1 8h-8c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h5v3c0 1.657 1.343 3 3 3h3v1c0 .552.448 1 1 1s1-.448 1-1v-2c.004-.02.004-.04 0-.06-.008-.093-.032-.184-.07-.27v-.09c-.048-.103-.112-.197-.19-.28l-6-6c-.085-.08-.183-.144-.29-.19h-.08c-.099-.057-.207-.094-.32-.11h-6c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h8c.552 0 1-.448 1-1s-.448-1-1-1h-.05zm-1-14.59L19.65 12h-1.58c-.552 0-1-.448-1-1V9.41zm5.57 14.88c-.048-.043-.098-.083-.15-.12-.11-.071-.232-.122-.36-.15-.326-.065-.664.036-.9.27-.19.188-.296.443-.296.71 0 .267.107.522.296.71.186.185.438.289.7.29.334.002.647-.164.834-.441.187-.277.223-.63.096-.939-.054-.122-.129-.233-.22-.33zM17.07 20h-5c-.552 0-1 .448-1 1s.448 1 1 1h5c.552 0 1-.448 1-1s-.448-1-1-1zm4.86-3c-1.072 0-2.064.571-2.6 1.5-.276.48-.11 1.094.37 1.37s1.094.11 1.37-.37c.243-.42.754-.606 1.21-.439.456.167.726.638.64 1.117-.086.478-.504.825-.99.822-.552 0-1 .448-1 1s.448 1 1 1c1.657 0 3-1.343 3-3s-1.343-3-3-3zm-9.86-3h1c.552 0 1-.448 1-1s-.448-1-1-1h-1c-.552 0-1 .448-1 1s.448 1 1 1z",
    transform: "translate(48 36)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesSurvey);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-survey.7e12dc92.svg";
export { ForwardRef as ReactComponent };